import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { formatPriceForDisplay } from '../../../../util/format-money';
import { PHOTO_MANAGER_SUBSCRIPTION_BILLING_PERIOD } from '../../../../apps/pro/views/Account/AccountPhotoManagerSettings/components/PhotoManagerSubscriptionCheckout/helpers';
import Button from '../../../../components/global/Button';
import { capitalize } from '../../../../util/text';
import CustomControl from '../../../../components/global/CustomControl';

const propTypes = {
  photoManagerSubscriptionItem: PropTypes.shape({
    id: PropTypes.string,
  }),
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  className: PropTypes.string,
  wrapperClassName: PropTypes.string,
  note: PropTypes.string,
};

const RegisterPhotoManagerButton = ({
  photoManagerSubscriptionItem,
  onClick,
  selected,
  className,
  wrapperClassName,
  note,
}) => {
  const classes = classNames({
    [className]: !!className,
    'register-view-photo-manager-button': true,
    selected,
  });

  return (
    <div className={wrapperClassName}>
      <Button
        btnStyle="reset"
        onClick={() => onClick(photoManagerSubscriptionItem)}
        className={classes}
      >
        <span className="register-view-photo-manager-button-title">
          {capitalize(photoManagerSubscriptionItem.billing_period)}
        </span>
        <span className="register-view-photo-manager-button-price">
          ${formatPriceForDisplay(photoManagerSubscriptionItem?.price.value)} /{' '}
          {photoManagerSubscriptionItem.billing_period ===
          PHOTO_MANAGER_SUBSCRIPTION_BILLING_PERIOD.MONTHLY
            ? 'month'
            : 'year'}
        </span>

        {note && (
          <span className="register-view-photo-manager-button-note">
            {note}
          </span>
        )}

        {selected && (
          <span className="register-view-photo-manager-button-checkmark">
            <CustomControl
              type="checkbox"
              id={photoManagerSubscriptionItem.id}
              label={photoManagerSubscriptionItem.id}
              labelSrOnly
              checked
              readOnly
            />
          </span>
        )}
      </Button>
    </div>
  );
};

RegisterPhotoManagerButton.propTypes = propTypes;

export default RegisterPhotoManagerButton;
